<template>
    <v-app id="app" v-bind:style="stylePagina" >
        <v-container fluid >
        <v-row justify="center" align="center"  class="mt-12 mb-12 pb-12"  >
            <v-col cols="12" lg="4" xl="4"  v-bind:style="styleCuadro" class="mt-12 pt-12 pb-12">
                <v-row justify="center" align="center" >
                    <v-col cols="12" xl="8" lg="8" >
                        <v-img style="width: 100%;" :src="logo"></v-img><br/>
                      <v-alert
                          :value="alerterror"
                          color="yellow"
                          dark
                          dismissible
                          border="top"
                          transition="scale-transition"
                      >
                        {{texterror}}
                      </v-alert>
                    </v-col>

                </v-row>
                <v-row justify="center" align="center" v-if="conformulario">
                    <v-col cols="10" sm="10" md="10" lg="10" xl="10" class="ma-2  pa-1">
                        <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   v-bind:style="styleComponent" v-model="editedItem.persona.nombrePersona" :placeholder="labelNombre" />
                    </v-col>

                    <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
                        <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="campodni" v-on:keyup="handleInputNumero" v-on:change="handleInputNumero"  v-bind:style="styleComponent" v-model="editedItem.persona.dniPersona" :placeholder="labelDNI" />
                    </v-col>
                    <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
                        <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   v-if="campotelefono"  v-on:keyup="handleInputNumero" v-on:change="handleInputNumero"  v-bind:style="styleComponent" v-model="editedItem.persona.telefonoPersona" :placeholder="labelTelefono" />
                    </v-col>
                    <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1">
                        <input type="email"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }" v-if="campoemail" v-on:change="handleEmailChange"   v-bind:style="styleComponent" @input="handleInput"  v-model="editedItem.persona.emailPersona"  :placeholder="labelEmail" />
                    </v-col>
                    <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
                        <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="camporef1"  v-bind:style="styleComponent" v-model="editedItem.persona.ref1Persona" :placeholder="labelRef1" />
                    </v-col>
                    <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
                        <input type="text" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"    v-if="camporef2"  v-bind:style="styleComponent" v-model="editedItem.persona.ref2Persona" :placeholder="labelRef2" />
                    </v-col>
                    <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
                        <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="campodireccion"  v-bind:style="styleComponent" v-model="editedItem.persona.direccionPersona" :placeholder="labelDireccion" />
                    </v-col>
                    <v-col cols="10" sm="10" md="10" lg="10" class="mt-4 mb-4" style="color: white !important; font-size:1.5rem;">
                    <v-row justify="center" align="center">
                        <v-col cols="3"><v-checkbox
                            v-model="editedItem.aceptoCondicion"
                            :rules="[v => !!v || 'Debes aceptar para continuar']"
                            label="Acepto los "
                            required
                            color="#ffffff"

                            :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"

                        ></v-checkbox></v-col>
                        <v-col cols="9">
                            <a style="text-decoration:none; color: white !important;" :href="linkcondiciones" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   target="_blank">Términos y Condiciones</a>
                        </v-col>
                    </v-row>
                         </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="ma-2  pa-1 text-center" >

                       <center> <v-btn v-bind:style="btnPag" @click="registrar">Registrarse</v-btn></center>
                    </v-col>
                </v-row>
                <v-row v-else justify="center" align="center" >
                    <v-col cols="12" lg="8">
                    <center>    <v-row class="doors">
                            <v-col col="4" class="door" ref="1">
                                <v-row class="boxes">
                                </v-row>
                            </v-col>

                            <v-col col="4" class="door" ref="2">
                                <v-row class="boxes">
                                </v-row>
                            </v-col>

                            <v-col col="4" class="door" ref="3">
                                <v-row class="boxes">
                                </v-row>
                            </v-col>
                        </v-row>
                    </center>
                        <v-row class="buttons">
                            <v-col cols="12">                  <center>          <v-btn class="button" v-bind:style="btnPag"  id="spinner" @click="spin">Jugar</v-btn></center>
                            </v-col>
                            <v-col cols="12">                 <center>             <v-btn class="button" v-bind:style="btnPag"  id="reseter" @click="volver">Volver</v-btn></center>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
          <v-overlay :value="overlay">
            <v-img
                src="@/assets/infinity.gif"

            />
          </v-overlay>
        </v-container>
    </v-app>
</template>

<script>
import axios from "axios";
import EmailAutocomplete from 'email-autocomplete';

export default {
    name: "SlotMachine",
    data() {
        return {
        items : [ '🌞', '🌈','🌟','🎁','https://tunayeventos.s3.us-east-2.amazonaws.com/mallaventura/logomall.png'],
            items2 : [ '🌝', '🌙','🎂','🌠','💚'],
            stocks:[],
            premios:[],
          isOnline: navigator.onLine,
          pool : ['https://tunayeventos.s3.us-east-2.amazonaws.com/mallaventura/logomall.png'],
            tag:'',
            emailRules: [
                v => !!v || 'E-mail es requerido',
                v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
            ],
            isWhitePlaceholder: true,
            unsolo:true,
            respuesta:[],

            volverbtn:false,
          ultimosganadores:0,
            alerterror:false,
            texterror:'',
            editedItem:{
            ganador:false,
                condiciones:false,
            persona:{
                    fechaNacimientoPersona:null,
                    dniPersona:'',
                    fotoPersona:'',
                    nombrePersona:'',
                    tipoDocumentoPersona:'',
                    emailPersona:'',
                    telefonoPersona:'',
                    direccionPersona:'',
                    sexoPersona:'',
                    distritoPersona:'',
                    ref1Persona:'',
                    ref2Persona:''
                     }

                    },
            defaultItem:{
                ganador:false,
                condiciones:false,
                persona:{
                    fechaNacimientoPersona:null,
                    dniPersona:'',
                    fotoPersona:'',
                    nombrePersona:'',
                    tipoDocumentoPersona:'',
                    emailPersona:'',
                    telefonoPersona:'',
                    direccionPersona:'',
                    sexoPersona:'',
                    distritoPersona:'',
                    ref1Persona:'',
                    ref2Persona:''
                }

            },
            juegodisenio: {},
            conformulario:false,
            grabarformulario:false,
            arrayganador:{},
            logo:'',
            overlay:false,
            campodireccion: false,
            campodistrito: false,
            campofecnac: false,
            campofoto: false,
            campoinvitado: false,
            campoizqder: false,
            camporeferido: false,
            camposexo: false,
            campotelefono: false,
            campofumador: false,
            campodni:false,
            campotipocarnet: false,
            campocondiciones:false,
            campoemail:false,
            camporef1: false,
            camporef2:false,
            condiciones: 'Soy Mayor de Edad',
            linkcondiciones:'',
            labelNombre:'Nombre',
            labelApellidoPaterno:'Apellido paterno',
            labelApellidoMaterno:'Apellido Materno',
            labelDNI:'Numero de Documento',
            labelDistrito: 'Comuna',
            labelTipoDocumento:'Tipo de Documento',
            labelFechaNacimiento: 'Fecha de nacimiento',
            labelEmail:'Correo Electrónico',
            labelSexo:'Género',
            labelTelefono:'Telefono',
            labelDireccion:'Direccion',
            labelRef1:'',
            labelRef2:'',
            stylePagina: {
                fontColor:'black',
                fontFamily: 'Futura Bk BT',
                color: '#1E3D90',
                height:'1920px',
                width:'100%',

                backgroundColor:'#FFD101'
            },
            styleComponent:{
                color:'#ffffff',
                backgroundColor:'#FFD101',
                width:'100%',
                padding:'2%',
                fontSize:'1.5rem',
            },
            styleCuadro:{
                color:'#1E3D90',
                backgroundColor:'#FFD101'
            },
            btnPag: {
                backgroundColor: '#1E3D90',
                color:'white',
                cursor: 'pointer',
                fontSize:'2.5rem',
                margin: '0 0.2rem',
                height:'100px',
                width: '75%',
                border: 'none',
                borderRadius: '10px',
                padding: '10px 15px',
            },
        }
    },
    created () {
        this.$vuetify.theme.dark = false
    },
    mounted(){
        this.comienzo();
    },
    methods:{
      comienzo(){

        this.editedItem.ganador = false;
        this.editedItem.condiciones = false;
        this.editedItem.persona.fechaNacimientoPersona = null
        this.editedItem.persona.dniPersona = ""
        this.editedItem.persona.fotoPersona = ""
        this.editedItem.persona.nombrePersona = ""
        this.editedItem.persona.tipoDocumentoPersona = ""
        this.editedItem.persona.emailPersona = ""
        this.editedItem.persona.telefonoPersona = ""
        this.editedItem.persona.direccionPersona = ""
        this.editedItem.persona.sexoPersona = ""
        this.editedItem.persona.distritoPersona = ""
        this.editedItem.persona.ref1Persona = ""
        this.editedItem.persona.ref2Persona = ""
        this.unsolo=true
            this.respuesta=[]
            this.volverbtn=false
        this.alerterror=false
            this.texterror=''
        this.conformulario=false
            this.grabarformulario=false
        this.tag =  this.$route.params.tag;
        this.damedisenio();
        const doors = document.querySelectorAll('.door');
        const domains = ['gmail.com', 'hotmail.com'];
        const autocompleteOptions = {
          domains: domains,
          topLevelDomains: ['com', 'net', 'org']
        };
        // Inicializar el autocompletar en el campo de email
        const emailInput = document.querySelector('input[type="email"]');
        const emailAutocomplete = new EmailAutocomplete(emailInput, autocompleteOptions);
        emailAutocomplete.on('autocompleted', domain => {
          if (this.editedItem.persona.emailPersona.includes('@')) {
            const [username] = this.editedItem.persona.emailPersona.split('@');
            this.editedItem.persona.emailPersona = username + '@' + domain;
          } else {
            this.editedItem.persona.emailPersona = domain;
          }
        });
        for (const door of doors) {
          const width = door.offsetWidth;
          door.style.height = `${width * 2}px`;
        }
      },
        handleEmailChange(event) {
            const inputValue = event.target.value;
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!regex.test(inputValue)) {
                // El valor no cumple con el formato de correo electrónico, se puede mostrar un mensaje de error o realizar alguna acción adicional.
                console.log('Formato de correo electrónico inválido');
                // También puedes restablecer el valor del campo de entrada si no cumple con el formato
                event.target.value = '';
            }
        },
        handleInput() {
            // Validar el formato del email
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.persona.emailPersona);

            if (isValidEmail) {
                // El email es válido
                console.log('Email válido: ' + this.editedItem.persona.emailPersona);
            } else {
                // El email no es válido
                console.log('Email inválido');
            }
        },

      handleInputNumero(event) {
        const inputValue = event.target.value;
        // Eliminar cualquier carácter que no sea un número
        const numericValue = inputValue.replace(/\D/g, '');
        // Actualizar el valor del campo de entrada solo con números
        event.target.value = numericValue;
      },
        volver(){
        this.respuesta =[];
        this.comienzo()
        this.conformulario = this.grabarformulario;

        this.volverbtn = false
        this.damestocks();
      },
        registrarRes(firstInit){
            if(!firstInit){
            console.log("Respuesta")
            console.log(this.respuesta)
            let vuelvejugar = false;
            let premioId = 0;
                if(this.unsolo){
                    this.unsolo = false;

            var bodyFormData = new FormData();
            bodyFormData.append("data",JSON.stringify(this.editedItem.persona))
            bodyFormData.append("tag",this.tag)
            bodyFormData.append("juego","SlotMachine")
                    var ganador = false;
            if(this.respuesta[0] === this.respuesta[1]){
                if(this.respuesta[2] === this.respuesta[1]){
                  console.log(this.respuesta[2])
                    let premio = this.premios.find(prize => prize.icono === this.respuesta[2]);
                    console.log("premio en respuesta")
                  console.log(premio)
                    if(premio.stock>0){
                        ganador = true
                        premioId = premio.id
                    }else{
                        vuelvejugar = true
                    }

                }
            }
            if(vuelvejugar){
                this.spin()
            }else{

            this.overlay = true
            bodyFormData.append("ganador",ganador)
            bodyFormData.append("premioId",premioId)
             axios
              .post('inscripciones/registrar',bodyFormData)
                .then(response => {
                    let ticketMin = response.data;
                    console.log(ticketMin)
                    this.volverbtn = true
                  this.overlay = false
                })
                .catch((error)  => {
                    console.log(error);
                  this.overlay = false
                });
            }
            }
            }
        },
        damestocks(){
        if(navigator.onLine) {
          axios
              .get('juegos/stocks/' + this.tag)
              .then(response => {
                this.premios = response.data
                this.dameUltimoGanador()
              })
              .catch((error) => {
                console.log(error);
              });
        }else{
          this.alerterror=true
          this.texterror="VERIFIQUE LA CONEXION A INTERNET"
          this.volver()}
        },
       dameUltimoGanador(){
        axios
            .get('juegos/ganadores/ultimos/'+this.juegodisenio.juego.id)
            .then(response => {
              this.ultimosganadores = response.data
              this.init()

            })
            .catch((error)  => {
              console.log(error);
            });

      },
        damedisenio(){
            axios
                .get('disenio/juego/'+this.tag)
                .then(response => {
                    this.juegodisenio = response.data;

                    this.logo = this.juegodisenio.logo;
                    this.conformulario = this.juegodisenio.juego.conFormulario;
                    this.grabarformulario = this.juegodisenio.juego.conFormulario;
                    this.styleCuadro.backgroundColor = this.juegodisenio.fondoCuadro + " !important";
                    this.stylePagina.backgroundColor = this.juegodisenio.backgroundColor + " !important";
                    this.styleComponent.backgroundColor = this.juegodisenio.backCabeceraColor + " !important";
                    this.styleComponent.color = this.juegodisenio.colorInput + " !important";
                    this.condiciones = this.juegodisenio.condiciones;
                    this.linkcondiciones = this.juegodisenio.linkCondiciones;
                    this.campoapmaterno= this.juegodisenio.campoapmaterno;
                    this.labelApellidoMaterno = this.juegodisenio.labelApmaterno;
                    this.labelApellidoPaterno = this.juegodisenio.labelAppaterno;
                    this.labelTelefono = this.juegodisenio.labelTelefono;
                    this.campotelefono = this.juegodisenio.campotelefono;
                    this.campoinvitado = this.juegodisenio.campoinvitado;
                    this.camposexo = this.juegodisenio.camposexo;
                    this.campodireccion = this.juegodisenio.campodireccion;
                    this.campodni = this.juegodisenio.campodni;
                    this.campodistrito = this.juegodisenio.campodistrito;
                    this.labelDireccion= this.juegodisenio.labelDireccion;
                    this.campofecnac  = this.juegodisenio.campofecnac;
                    this.campoemail = this.juegodisenio.campoemail;
                    this.logoexist = this.juegodisenio.logoCargado;
                    this.logoimg = this.juegodisenio.logo;
                    this.stylePagina.color = this.juegodisenio.colorText + " !important";
                    this.btnPag.color = this.juegodisenio.colorTxtBoton + " !important";
                    this.btnPag.backgroundColor = this.juegodisenio.colorBgBoton+ " !important";
                    this.labelRef1 = this.juegodisenio.labelRef1;
                    this.labelRef2 = this.juegodisenio.labelRef2;
                    this.camporef1 = this.juegodisenio.camporef1;
                    this.camporef2 = this.juegodisenio.camporef2;
                    this.stylePagina.backgroundImage = "url('"+this.juegodisenio.backgroundImage+"')";
                    this.damestocks();

                })
                .catch((error)  => {
                    console.log(error);
                });
        },
        registrar(){
          if(navigator.onLine){
            if(!this.editedItem.condiciones){
                if(this.editedItem.persona.nombrePersona.length > 2){
                            if(this.editedItem.persona.emailPersona.length > 6){
                                if(this.editedItem.persona.direccionPersona.length > 1){
            this.conformulario=false
                                }else{
                                    this.alerterror = true;
                                    this.texterror= "Debes Completar una Dirección correcta"
                                }
                            }else{
                                this.alerterror = true;
                                this.texterror= "Debes Completar un Correo correcto"
                            }


                }else{
                    this.alerterror = true;
                    this.texterror= "Debes Completar tu nombre"
                }
            }else{
                this.alerterror = true;
                this.texterror= "Debes Aceptar los Términos y Condiciones"
            }}else{
            this.alerterror=true
            this.texterror="VERIFIQUE LA CONEXION A INTERNET"
            this.volver()
          }
        },
        compruebastock(arr){
        return new Promise((resolve) => {
          this.overlay = true
        console.log("Premio")
              if(navigator.onLine){
          axios
              .get('juegos/stocks/'+this.tag)
              .then(response => {
                this.premios = response.data
                let premio = this.premios.find(prize => prize.icono === this.arrayganador[this.arrayganador.length - 1]);
                console.log(premio)
                if(premio.stock>0){
                  console.log("ARRAY GANADOR")
                  console.log(this.arrayganador)
                  this.overlay = false
                  resolve();
                }else{
                  this.arrayganador = this.shuffleArray(arr)
                  this.compruebastock(arr).then(() => {
                    this.overlay = false
                    resolve();
                  });

                }
              })
              .catch((error)  => {
                console.log(error);
                resolve();
              });
              }else{
                this.alerterror=true
                this.texterror="VERIFIQUE LA CONEXION A INTERNET"
                this.volver()
              }
        });
      },
      async init(firstInit = true, groups = 1, duration = 1) {
          const min = 5;
          const max = 15;
          const numeroAleatorio = Math.floor(Math.random() * (max - min + 1)) + min;

            const doors = document.querySelectorAll('.door');

          var conta = 0;
            for (const door of doors) {
              conta++
                if (firstInit) {
                    door.dataset.spinned = '0';
                } else if (door.dataset.spinned === '1') {
                    return;
                }
                const width = door.offsetWidth;
                door.style.height = `${width * 2}px`;

                const boxes = door.querySelector('.boxes');
                const boxesClone = boxes.cloneNode(false);
                const pool = [];

                if (!firstInit) {
                  if(!navigator.onLine){
                    this.alerterror=true
                    this.texterror="VERIFIQUE LA CONEXION A INTERNET"
                    this.volver()
                  }

                  var ganan = false;
                  console.log(numeroAleatorio);
                  const stockDisponible = this.premios.some(prize => prize.stock > 0);
                  if(stockDisponible){
                  if(numeroAleatorio<this.ultimosganadores){
                    ganan = true;
                  }}
                  console.log("Stock Dispo")
                  console.log(stockDisponible)
                    const arr = [];

                    for (let n = 0; n < (groups > 0 ? groups : 1); n++) {
                        arr.push(...this.premios.map(premio => premio.icono));
                    }
                  console.log('ARR: '+conta)
                  console.log(arr)
                  if(conta === 1){
                    this.arrayganador = this.shuffleArray(arr)
                    if(stockDisponible){
                    await this.compruebastock(arr)
                    }
                  }

                  if(ganan){
                    pool.push(...this.arrayganador)
                  }else{
                    if(conta ===3 && !stockDisponible){
                      this.arrayganador = this.shuffleArray(arr)

                      await this.compruebastock(arr)
                      pool.push(...this.arrayganador)
                    }else{
                      pool.push(...this.shuffleArray(arr));
                    }
                  }

                  this.respuesta.push(pool[pool.length-1])
                  console.log('Respuesta: '+this.respuesta)
                  console.log(this.respuesta)

                    console.log('Pool: '+conta)
                    console.log(pool)
                    boxesClone.addEventListener(
                        'transitionstart',
                        function () {
                            door.dataset.spinned = '1';
                            this.querySelectorAll('.box').forEach((box) => {
                                box.style.filter = 'blur(1px)';
                            });
                        },
                        { once: true }
                    );

                    boxesClone.addEventListener(
                        'transitionend',
                        function () {
                            
                            this.querySelectorAll('.box').forEach((box, index) => {
                                box.style.filter = 'blur(0)';
                                if (index > 0){
                                    this.removeChild(box);
                                }else{
                                    box.setAttribute("ref","final")
                                }
                            });
                        },
                        { once: true }
                    );
                }

                for (let i = pool.length - 1; i >= 0; i--) {
                    const box = document.createElement('v-col');
                    box.classList.add('box');
                    box.style.width = door.clientWidth + 'px';
                    box.style.height = door.clientHeight + 'px';
                    box.style.fontSize = door.clientWidth*0.75 + 'px';
                    const element = pool[i];

                    if (this.isEmoji(element)) {
                        // Si el elemento es un emoji
                        box.textContent = pool[i];

                    } else {
                        // Si el elemento no es un emoji (es una URL de imagen)
                        const img = document.createElement('img');
                        img.src = element;
                        img.style.width = '85%';

                        box.appendChild(img);
                    }

                    boxesClone.appendChild(box);
                }
                boxesClone.style.transitionDuration = `${duration > 0 ? duration : 1}s`;
                boxesClone.style.transform = `translateY(-${door.clientHeight * (pool.length - 1)}px)`;
                door.replaceChild(boxesClone, boxes);
            }
            this.registrarRes(firstInit)
        },
        isEmoji(element) {
            const emojiRegex = /[\u{1F300}-\u{1F6FF}]/u; // Expresión regular para emojis

            return emojiRegex.test(element);
        },
        async spin() {
        if(navigator.onLine){
            await this.init(false, 1, 5)
            this.registrarRes()
            const doors = document.querySelectorAll('.door');

            for (const door of doors) {
                const boxes = door.querySelector('.boxes');
                const duration = parseInt(boxes.style.transitionDuration);
                boxes.style.transform = 'translateY(0)';
                await new Promise((resolve) => setTimeout(resolve, duration * 100));
            }
        }else{
          this.alerterror=true
          this.texterror="VERIFIQUE LA CONEXION A INTERNET"
          this.volver()
        }
        },
        shuffleArray(arr) {
            let m = arr.length;
            while (m) {
                const i = Math.floor(Math.random() * m--);
                [arr[m], arr[i]] = [arr[i], arr[m]];
            }
            return arr;
        }
    }
}
</script>

<style >




.door {
    background: #fafafa;
    height: 110px;
    overflow: hidden;
    border-radius: 5px;
    margin-right: 5px;
}

.boxes {
    /* transform: translateY(0); */
    transition: transform 1s ease-in-out;
}

.box {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 4rem;
}
.white-placeholder::placeholder {
    color: white;
}
.black-placeholder::placeholder {
    color: black;
}
.buttons {
    margin: 1rem 0 2rem 0;
}

.v-input__control .v-input__slot .v-label{
    color:white !important;
    font-size:1.5rem;

}

.info {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
}

</style>